import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from "@angular/core";
import { CommonModule } from "@angular/common";
import { ReactiveFormsModule } from "@angular/forms";

import { LgdSelectComponent } from "./lgdSelect.component";

import { defineSelectComponent, defineOptionComponent } from "@tylertech/forge";
import { ForgeModule } from "@tylertech/forge-angular";

defineSelectComponent();
defineOptionComponent();

@NgModule({
    imports: [
        CommonModule,
        ReactiveFormsModule,
        ForgeModule,
    ],
    declarations: [LgdSelectComponent],
    exports: [
        ReactiveFormsModule,
        LgdSelectComponent
    ],
    providers: [],
    schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class LgdSelectModule { }
